import Container from "@/components/ContentContainer/Container";
import InnerContainer from "@/components/ContentContainer/InnerContainer";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { Flex } from "antd";
import { useParams } from "react-router-dom";
import styles from "./ProductRelations.module.scss";
import ProductOrdeRelations from "./ProductRelations/ProductOrderRelations";
import ProductProxyRelations from "./ProductRelations/ProductProxyRelations";

export default function ProductRelations() {
  const { productId: id } = useParams();
  const productId = Number(id);

  useTrackOnLoad("Product Details Viewed");

  if (!productId) throw Error("No product ID found.");

  return (
    <Flex>
      <Container
        padding={false}
        className={styles.container}
        noRoundedTop
      >
        <Flex>
          <InnerContainer
            contentClassName={styles.relations}
            borderRight
          >
            <ProductProxyRelations productId={productId} />
          </InnerContainer>

          <InnerContainer contentClassName={styles.relations}>
            <ProductOrdeRelations productId={productId} />
          </InnerContainer>
        </Flex>
      </Container>
    </Flex>
  );
}
